/**
 * <AbsencePickerStep> — l'étape « Quelle absence ? » (organism).
 *
 * Les absences à rattraper de l'enfant, une option par absence. Celles qui ne se rattrapent plus
 * restent dans la liste, grisées, et disent pourquoi — elles ne disparaissent pas sans
 * explication. L'échéance proche porte une chip : c'est la seule chose qui presse.
 *
 * Contrôlé : le choix arrive en `selectedId`, repart par `onSelect`. Les libellés arrivent écrits
 * par l'adaptateur ; ce composant ne compte aucun jour.
 */
import React from "react"

import { Stack } from "../../atoms/containers/Stack"
import { Text } from "../../atoms/typography/Text"
import { OptionCard } from "../../molecules/OptionCard"
import { type UIParentRecoveryAbsence } from "../../../ports/primary/ui/types"

export type AbsencePickerStepProps = {
    absences: UIParentRecoveryAbsence[]
    selectedId?: UIParentRecoveryAbsence["id"]
    onSelect: (absence: UIParentRecoveryAbsence) => void
    /** Une phrase au-dessus de la liste — ce que le parcours dit quand rien ne se rattrape encore. */
    notice?: string
    testID?: string
}

export function AbsencePickerStep(props: AbsencePickerStepProps) {
    const { absences, selectedId, onSelect, notice, testID } = props

    return (
        <Stack gap="4" testID={testID}>
            {notice != null && notice !== "" && <Text color="text-muted">{notice}</Text>}
            {absences.length > 0 && (
                <Stack gap="2">
                    {absences.map((absence) => (
                        <OptionCard
                            key={absence.id}
                            label={absence.label}
                            description={absence.detail}
                            badge={absence.urgency}
                            badgeVariant="danger"
                            disabled={!absence.recoverable}
                            disabledReason={absence.unavailableReason}
                            selected={absence.id === selectedId}
                            onPress={() => onSelect(absence)}
                        />
                    ))}
                </Stack>
            )}
        </Stack>
    )
}
